import {
  SET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
  SET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
  SET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
  SET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
  SET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
  SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
  SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
  SET_MULTIMODE_RATE_COMPARISON_WAGON_TYPES_LIST,
  SET_ORIGIN_DESTINATION_YARD_LIST,
  SET_RAIL_RAKE_LIST,
} from "Constants/actionConstants";
import {
  GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_ROAD_FREIGHT_RATE_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST_URL,
  GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST_URL,
  GET_ORIGIN_DESTINATION_YARD_LIST_URL,
  GET_RAIL_RAKE_LIST_URL,
} from "Utils/api";
import axiosT1 from "Utils/axios";
import { call, put } from "redux-saga/effects";
import { delay } from "redux-saga";

export function* getMultimodeRateComparisonSoureDestinationList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST_URL
    );

    let source = resData.data.data.source.map((ele) => {
      const newObject = {
        label: ele,
        value: ele,
      };
      return newObject;
    });

    let destination = resData.data.data.destination.map((ele) => {
      const newObject = {
        label: ele,
        value: ele,
      };
      return newObject;
    });

    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
      payload: {
        source,
        destination,
      },
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getMultimodeRateComparisonCommodityCategoryList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST_URL
    );

    let commodityCategories = resData.data.data.commodityCategory.map((ele) => {
      const newObject = {
        label: ele,
        value: ele,
      };
      return newObject;
    });

    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
      payload: commodityCategories,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getMultimodeRateComparisonFreightRateList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST_URL,
      {
        params: action.payload.queryParams,
      }
    );

    const roadFreight = resData.data.data.road_freight || [];
    const railFreightBcn = resData.data.data.rail_freight_bcn || [];
    const lowestFreight = resData.data.data.lowest_freight || {};

    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
      payload: {
        roadFreight,
        railFreightBcn,
        lowestFreight,
      },
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getMultimodeRateComparisonFreightDaysList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST_URL
    );

    const freightDays = resData.data.data.map((ele) => {
      return {
        ...ele,
        label: `Last ${ele.value} Days Avg.`,
      };
    });
    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
      payload: freightDays,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getMultimodeRateComparisonVehicleDetailsList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST_URL
    );
    let vehicleDetails = resData.data.data.vehicleTypes || [];
    vehicleDetails = vehicleDetails.map((ele) => {
      return {
        label: ele,
        value: ele,
      };
    });
    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
      payload: vehicleDetails,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getMultimodeRateComparisonViewDetailsRoadFreightRateList(
  action
) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST_URL,
      {
        params: action.payload.queryParams,
      }
    );

    const viewDetailsRoadFreight = resData.data.data.road_freight || [];

    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
      payload: viewDetailsRoadFreight,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getMultimodeRateComparisonViewDetailsRailFreightRateList(
  action
) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST_URL,
      {
        params: action.payload.queryParams,
      }
    );

    const viewDetailsRailFreightBcn = resData.data.data.rail_freight_bcn || [];
    let wagonTypes = resData.data.data.wagon_type || [];
    wagonTypes = wagonTypes.map((ele) => {
      return {
        label: `${ele.wagon} MT`,
        value: ele.wagon,
        ...ele,
      };
    });

    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
      payload: viewDetailsRailFreightBcn,
    });

    yield put({
      type: SET_MULTIMODE_RATE_COMPARISON_WAGON_TYPES_LIST,
      payload: wagonTypes,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getRailRakeList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_RAIL_RAKE_LIST_URL);
    let railRakeList = resData.data.data || [];
    railRakeList = railRakeList.map((ele) => {
      return {
        ...ele,
        label: ele.name,
        value: ele.name,
      };
    });
    yield put({
      type: SET_RAIL_RAKE_LIST,
      payload: railRakeList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getOriginDestinationYardList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_ORIGIN_DESTINATION_YARD_LIST_URL
    );
    let originYardList = resData.data.data.origin_yard || [];
    let destinationYardList = resData.data.data.destination_yard || [];

    originYardList = originYardList.map((ele) => {
      return {
        label: ele,
        value: ele,
      };
    });

    destinationYardList = destinationYardList.map((ele) => {
      return {
        label: ele,
        value: ele,
      };
    });

    yield put({
      type: SET_ORIGIN_DESTINATION_YARD_LIST,
      payload: {
        originYardList,
        destinationYardList,
      },
    });
  } catch (e) {
    console.log("e:", e);
  }
}
